import { Checkbox } from '@symphony-ui/uitoolkit-components';
import SelectionStatus from '@symphony-ui/uitoolkit-components/components/selection/SelectionStatus';
import * as React from 'react';
const WebPushCheckbox = ({ row }) => (React.createElement("div", { className: "co-transaction-checkbox", style: { justifyContent: 'center !important' } },
    React.createElement(Checkbox, { status: row.getIsSelected() ? SelectionStatus.CHECKED : SelectionStatus.UNCHECKED, name: `check${row.index}`, onClick: row.getToggleSelectedHandler(), value: "" })));
export default WebPushCheckbox;
